//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userListApi } from '@/api/user';
export default {
  name: 'UserList',
  props: {
    userType: {
      type: String,
      default: 'collect'
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      tableFrom: {
        page: 1,
        limit: 10,
        nikename: '',
        searchType: 'all',
        content: '',
        userType: this.userType
      },
      tableData: [],
      total: null
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    changeRow: function changeRow(row) {
      // this.selectedRow = row;
      this.$emit('getRow', row);
    },
    initList: function initList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      userListApi(this.tableFrom).then(function (res) {
        _this.tableData = res.list;
        _this.total = res.total;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //页数更改
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.getList();
    }
  }
};